import * as fromStats from '~/store/reducers/stats';

export const getStats = (state) => fromStats.getStats(state);
export const getStatsIsFetched = (state) => fromStats.getIsFetched(state);
